import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";

export default function HelpModal({ open, onClose }) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-lg bg-[#0f0d0e] text-white border-white/10 max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-white text-lg">🗺️ Bienvenue sur UrbSex</DialogTitle>
        </DialogHeader>

        <div className="text-sm text-white/80 space-y-4 pr-1">
          <p>
            UrbSex, c'est une carte collaborative des spots de cruising extérieur — discrète et communautaire.
          </p>

          <hr className="border-white/10" />

          <div className="space-y-3">
            <h3 className="text-white font-semibold">Comment ça marche ?</h3>
            <ul className="space-y-3 list-none pl-0">
              <li>
                <span className="font-medium text-white">Consulte la carte</span> — les spots sont visibles sans compte. Pour voir la description, les photos et les infos complètes, crée un compte. C'est gratuit et ça prend 30 secondes.
              </li>
              <li>
                <span className="font-medium text-white">Ajoute un spot</span> — clique sur "+ Ajouter un spot", place le marqueur sur la carte, décris l'endroit en quelques mots (200 caractères max, pas besoin de roman). Choisis une catégorie : <em>Facile</em> (accessible, peu de risques), <em>Audacieux</em> (ça demande un peu de culot), <em>Temporaire</em> (profites-en maintenant). Ajoute des tags : Nature, Discret, Nocturne, Fréquenté…
              </li>
              <li>
                <span className="font-medium text-white">Laisse une trace</span> — sur tes spots comme sur ceux des autres. 🗺️ <em>J'y suis passé</em> si tu confirmes que le spot est accessible, 🔥 <em>Régulier</em> si tu y retournes souvent, 🫦 <em>Envie</em> si ça t'attire mais t'as pas encore sauté le pas. Ça aide la communauté à savoir si un spot est toujours bon.
              </li>
              <li>
                <span className="font-medium text-white">Signale</span> — un spot qui n'existe plus ou qui pose problème ? Le bouton est là.
              </li>
            </ul>
          </div>

          <hr className="border-white/10" />

          <div className="space-y-2">
            <h3 className="text-white font-semibold">L'essentiel à savoir</h3>
            <p>
              UrbSex ne partage aucune donnée personnelle. Pas de pub, pas de tracking. C'est un projet perso pour la communauté.
            </p>
            <p>
              Et justement — pas de pub, ça veut dire que la carte ne grossit que si t'en parles autour de toi (aux kinkys que ça intéresse évidemment).
            </p>
          </div>

          <hr className="border-white/10" />

          <div className="space-y-2">
            <h3 className="text-white font-semibold">Ta mission</h3>
            <p>
              UrbSex démarre. La carte est encore clairsemée — et c'est là que t'entres en jeu.
            </p>
            <p>
              On ne cherche pas seulement les spots connus de tous. On cherche <em>tes</em> spots : les coins discrets que t'as trouvés par hasard, les recoins que personne ne documente, les petits endroits tranquilles loin des radars. C'est ça qui rend une carte vraiment utile.
            </p>
            <p className="font-medium text-white">
              Les premiers utilisateurs construisent quelque chose. Sois-en.
            </p>
          </div>
        </div>

        <div className="pt-2">
          <Button
            onClick={onClose}
            className="w-full bg-white/10 hover:bg-white/20 text-white border border-white/20"
          >
            Fermer
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
